import styled from "styled-components"

import '../GlobalStyle.css';

const ProgramsList = styled.div`
span{
    color: #0478c2;
}

.program:after {
    content: "";
    animation: programs 10s linear infinite;

    @keyframes programs {
        0% {
            content: "rebate";
        }

        20% {
            content: "channel sales";
        }

        40% {
            content: "ebike incentive";
        }

        60% {
            content: "referral";
        }

        80% {
            content: "sales contest";
        }

        100% {
            content: "custom incentive";
        }

    }
}
`

const ProgramsAppearList = () => {
    return (
        <>
            <ProgramsList className='fs-60'>
                <span className='program'></span>
            </ProgramsList>
        </>
    );
}

export default ProgramsAppearList;